var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActiviteIcon, LicenceIcon, AdministrationIcon, AffaireIcon, ClientIcon, CollaborateurIcon, HomeIcon, KanbanIcon, StatistiqueIcon, } from '../utils/Icons';
import { Link } from '../utils/Link';
import { classLinkMenu, getColor, getColors } from '../utils/Classes';
import { ListItemText, MenuItem, Stack } from '@mui/material';
import { getOriginalUser } from '../services/utilisateur';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
export var Navigation = function (_a) {
    var displayMenuMax = _a.displayMenuMax;
    var originalUser = getOriginalUser();
    var palette = getColors();
    var convertLocationToPage = function (location) {
        return location.pathname.split('/').length > 1
            ? location.pathname.split('/')[1]
            : '';
    };
    var _b = useState(convertLocationToPage(window.location)), pageSelected = _b[0], setPageSelected = _b[1];
    var history = useHistory();
    useEffect(function () {
        return history.listen(function (location) {
            setPageSelected(convertLocationToPage(location));
        });
    }, [history]);
    return (_jsx(_Fragment, { children: [
            {
                value: '',
                color: 'header',
                icon: HomeIcon,
                label: 'Accueil',
                display: true,
            },
            {
                value: 'collaborateur',
                color: 'collaborateur',
                icon: CollaborateurIcon,
                label: 'Collaborateurs',
                display: true,
            },
            {
                value: 'client',
                color: 'client',
                icon: ClientIcon,
                label: 'Clients',
                display: true,
            },
            {
                value: 'affaire',
                color: 'affaire',
                icon: AffaireIcon,
                label: 'Affaires',
                display: true,
            },
            {
                value: 'activite',
                color: 'activite',
                icon: ActiviteIcon,
                label: 'Activités',
                display: true,
            },
            {
                value: 'kanban',
                color: 'header',
                icon: KanbanIcon,
                label: 'Kanban',
                display: true,
            },
            {
                value: 'statistique',
                color: 'header',
                icon: StatistiqueIcon,
                label: 'Statistiques',
                display: originalUser.CanReadStatistique || originalUser.CanReadRequete,
            },
            {
                value: 'administration',
                color: 'header',
                icon: AdministrationIcon,
                label: 'Administration',
                display: originalUser.IsAdministrateur,
            },
            {
                value: 'licence',
                color: 'header',
                icon: LicenceIcon,
                label: 'Licences',
                display: originalUser.IsAdministrateur && originalUser.SuperAdminKey,
            },
        ].map(function (item) {
            if (!item.display) {
                return;
            }
            var Icon = item.icon;
            return (_jsx(Link, __assign({ style: classLinkMenu(item.value === pageSelected, item.color), to: "/".concat(item.value) }, { children: _jsx(MenuItem, __assign({ className: "p-xsmall m-xsmall", onClick: function () { return setPageSelected(item.value); }, sx: {
                        border: '2px solid ' +
                            (item.value === pageSelected
                                ? getColor(palette, item.color)
                                : 'transparent'),
                        borderRadius: '25px',
                    } }, { children: _jsxs(Stack, __assign({ className: "w-full", direction: "row", justifyContent: "center", alignItems: "center", spacing: 2 }, { children: [_jsx(Icon, { className: displayMenuMax ? 'ml-xsmall' : '', sx: classLinkMenu(item.value === pageSelected, item.color), fontSize: "small" }), displayMenuMax && (_jsx(ListItemText, __assign({ primaryTypographyProps: {
                                    style: {
                                        fontWeight: item.value === pageSelected ? 'bold' : 'inherit',
                                    },
                                } }, { children: item.label })))] })) })) }), item.value));
        }) }));
};
//# sourceMappingURL=Navigation.js.map